import { defineNuxtPlugin } from '#app/nuxt'
import { LazyAppIcon, LazyCard, LazyCreateNewClaimHyperlink, LazyIconCard, LazyShipmentCard, LazyStepSubtitle, LazyParcelLab, LazyDropArea, LazyMediaUploader, LazyBaseModal, LazyCollectSignatureModal, LazyEditInStoreDetailsModal, LazyEditShippingAddressModal, LazyItemsModal, LazyOtaModal, LazyOutOfWarrantyModal, LazyProcessFileClaim, LazyProcessReturns, LazyProcessShippingClaims, LazyProcessWarrantyClaims, LazyReturnsCard, LazyShippingClaimsCard, LazyPulseAiProductFinderModal, LazyPulseConfirmShippingAddress, LazyPulseDeliveryIssueDetails, LazyPulseDeliveryIssueDropdown, LazyPulseDeliveryIssueOptions, LazyPulseItemCard, LazyPulseItemIssueCard, LazyPulseItemIssueDetailModal, LazyPulseItemIssueDetailModalForm, LazyPulseItemIssueDetailModalProgressBar, LazyPulseItemIssueDetailModalSelectCount, LazyPulseItemIssueDetailModalSelectGranularity, LazyPulseItemIssueDetails, LazyPulseOrderIssueOptions, LazyPulseProductNotFoundForm, LazyPulseRendered, LazyPulseResolutionOptions, LazyPulseSearchWarrantyProductsModal, LazyPulseShippingAddress, LazyPulseUnavailableItemsResolution, LazyPulseUploadedReceipts, LazyPulseContactInfoStep, LazyPulseDateOfPurchaseStep, LazyPulseProductSearchStep, LazyPulseReceiptStep, LazyPulseReceiptUploadSection, LazyPulseResolutionStep, LazyPulseBadge, LazyPulseEmptyState, LazyPulseLoadingSpinner, LazyPulseMediaCarousel, LazyPulseTooltip, LazyPulseBanner, LazyPulseBaseModal, LazyPulseChatAttachment, LazyPulseCheckRadioButton, LazyPulseClaimFeed, LazyPulseClaimMetric, LazyPulseCustomerAddress, LazyPulseCustomerAddresses, LazyPulseDataMetric, LazyPulseFeedback, LazyPulseFulfillmentInfo, LazyPulseInfoBanner, LazyPulseMessagingEvent, LazyPulseMessagingEventDivider, LazyPulseMessagingFeed, LazyPulseModal, LazyPulsePlatformAvatar, LazyPulseProductDisplay, LazyPulseReshipRefundResolutionDetails, LazyPulseStatusBadge, LazyPulseSuccessBanner, LazyPulseTagList, LazyPulseToggleDisplay, LazyPulseTrackingInfo, LazyPulseUserAvatar, LazyPulseWarningBanner, LazyPulseTable, LazyPulseTableGridSkeleton, LazyPulseTableSkeleton, LazyPulseAddBook, LazyPulseApiLogo, LazyPulseArmraLogo, LazyPulseArrowsRightLeft, LazyPulseBigCommerce, LazyPulseCart, LazyPulseCheckCircle, LazyPulseCheckoutBag, LazyPulseChevronLeft, LazyPulseCircleLogo, LazyPulseClaimInfoSubscribedRightArrows, LazyPulseClaimTodoApprovedDeniedSolidArrow, LazyPulseClaimTodoClosedSolidArrow, LazyPulseClaimTodoDashedArrow, LazyPulseClaimTodoOnholdDashedArrow, LazyPulseClaimTodoPendingDashedArrow, LazyPulseClaimTodoSolidLine, LazyPulseDatePicker, LazyPulseEarthGlobeTimezone, LazyPulseFolderCheck, LazyPulseFollowUp, LazyPulseIconApprove, LazyPulseIconArmra, LazyPulseIconAvatar, LazyPulseIconBuilding, LazyPulseIconCheck, LazyPulseIconClose, LazyPulseIconCreditCard, LazyPulseIconCustom, LazyPulseIconDanger, LazyPulseIconDollar, LazyPulseIconDrag, LazyPulseIconEdit, LazyPulseIconGoogle, LazyPulseIconInfo, LazyPulseIconLock, LazyPulseIconLogo, LazyPulseIconRefund, LazyPulseIconSave, LazyPulseIconSend, LazyPulseIconShipment, LazyPulseIconShopify, LazyPulseIconWarning, LazyPulseImageCancel, LazyPulseInbox, LazyPulseLineAlign, LazyPulseLineAlphabet, LazyPulseLineAngleDoubleLeft, LazyPulseLineAngleDoubleRight, LazyPulseLineAngleDown, LazyPulseLineAngleLeft, LazyPulseLineAngleRight, LazyPulseLineAngleUp, LazyPulseLineAppleAlt, LazyPulseLineArchive, LazyPulseLineArrow, LazyPulseLineArrowDownRight, LazyPulseLineArrowLeft, LazyPulseLineArrowRight, LazyPulseLineAt, LazyPulseLineBalanceScale, LazyPulseLineBars, LazyPulseLineBell, LazyPulseLineBold, LazyPulseLineBolt, LazyPulseLineBookMedical, LazyPulseLineBox, LazyPulseLineBrain, LazyPulseLineBuilding, LazyPulseLineCameraPlus, LazyPulseLineCameraQuestion, LazyPulseLineCancel, LazyPulseLineChart, LazyPulseLineChatBubbleUser, LazyPulseLineCheckCircle, LazyPulseLineCircle, LazyPulseLineClipboardAlt, LazyPulseLineClockThree, LazyPulseLineCodeBranch, LazyPulseLineCoins, LazyPulseLineCommentAlt, LazyPulseLineCommentAltBlock, LazyPulseLineCommentDots, LazyPulseLineCommentMessage, LazyPulseLineCommentQuestion, LazyPulseLineComparison, LazyPulseLineCopy, LazyPulseLineCornerUpLeftAlt, LazyPulseLineCornerUpRightAlt, LazyPulseLineCreditCard, LazyPulseLineDashboard, LazyPulseLineDownloadAlt, LazyPulseLineDraggabledots, LazyPulseLineEdit, LazyPulseLineEditAlt, LazyPulseLineEllipsisH, LazyPulseLineExclamationCircle, LazyPulseLineExclamationOctagon, LazyPulseLineExport, LazyPulseLineExternalLinkAlt, LazyPulseLineEye, LazyPulseLineEyeSlash, LazyPulseLineFileCopyAlt, LazyPulseLineFileLandscape, LazyPulseLineFilter, LazyPulseLineFire, LazyPulseLineFolder, LazyPulseLineFolderOpen, LazyPulseLineFont, LazyPulseLineGithubAlt, LazyPulseLineGlobe, LazyPulseLineImage, LazyPulseLineImageBroken, LazyPulseLineImport, LazyPulseLineInbox, LazyPulseLineInfoCircle, LazyPulseLineItalic, LazyPulseLineLeftIndent, LazyPulseLineLinkAlt, LazyPulseLineListOl, LazyPulseLineListUl, LazyPulseLineLock, LazyPulseLineMapPinAlt, LazyPulseLineMessage, LazyPulseLineMicrophone, LazyPulseLineMinusCircle, LazyPulseLineMoney, LazyPulseLineMoneyWithdraw, LazyPulseLineMoon, LazyPulseLineMultiply, LazyPulseLinePalette, LazyPulseLinePaperclip, LazyPulseLinePen, LazyPulseLinePhone, LazyPulseLinePlug, LazyPulseLinePlus, LazyPulseLinePlusCircle, LazyPulseLinePlusSquare, LazyPulseLineRedo, LazyPulseLineRefresh, LazyPulseLineRightIndentAlt, LazyPulseLineRobot, LazyPulseLineRocket, LazyPulseLineSearch, LazyPulseLineSetting, LazyPulseLineShield, LazyPulseLineShieldCheck, LazyPulseLineShoppingBag, LazyPulseLineSlack, LazyPulseLineSort, LazyPulseLineStar, LazyPulseLineSun, LazyPulseLineSwatchbook, LazyPulseLineSync, LazyPulseLineTable, LazyPulseLineTag, LazyPulseLineTimes, LazyPulseLineTimesCircle, LazyPulseLineToggleOff, LazyPulseLineToggleOn, LazyPulseLineTransaction, LazyPulseLineTrashAlt, LazyPulseLineTruck, LazyPulseLineUnderline, LazyPulseLineUpload, LazyPulseLineUsdCircle, LazyPulseLineUsersAlt, LazyPulseLineWrench, LazyPulseLoopreturns, LazyPulseMagentoLogo, LazyPulseNoResponse, LazyPulseOutlineCube, LazyPulseOutlineEnvelope, LazyPulseOutsideOp, LazyPulsePackage, LazyPulsePackageArrived, LazyPulsePlayCircle, LazyPulsePlusCircle, LazyPulseQueueList, LazyPulseRefreshResentMail, LazyPulseRiseaiLogo, LazyPulseShieldCheck, LazyPulseShipstation, LazyPulseShopifyAvatar, LazyPulseShopifyBag, LazyPulseSolidCheckCircle, LazyPulseSolidStar, LazyPulseTableDeleteColumn, LazyPulseTableDeleteRow, LazyPulseTableInsertColumnAfter, LazyPulseTableInsertColumnBefore, LazyPulseTableInsertRowAbove, LazyPulseTableInsertRowAfter, LazyPulseTableOptions, LazyPulseTableSettings, LazyPulseTipaltiLogo, LazyPulseTrackstar, LazyPulseXCircle, LazyPulseXMark, LazyPulseAccordionCard, LazyPulseBasicCard, LazyPulseItemsAccordion, LazyPulsePageIcon, LazyPulseShippingClaim, LazyPulseSingleClaim, LazyPulseTabbedNav, LazyPulseWarrantyClaim, LazyPulseButton, LazyPulseButtonCard, LazyPulseChatImageUploader, LazyPulseColorInput, LazyPulseCustomDatePicker, LazyPulseDateRangePicker, LazyPulseDropdown, LazyPulseIconButton, LazyPulseInput, LazyPulseLabelPopper, LazyPulseMessageBox, LazyPulseMultiDropdown, LazyPulseMultiSelectDropdown, LazyPulseOptionsMenu, LazyPulsePasswordInput, LazyPulseRadioButton, LazyPulseRadioQuestion, LazyPulseRangeSlider, LazyPulseRteFileComponent, LazyPulseRteMentionList, LazyPulseRteVideoComponent, LazyPulseRichTextEditor, LazyPulseSelect, LazyPulseTagSelect, LazyPulseTextArea, LazyPulseToggle, LazyPulseValidationGroup } from '#components'
const lazyGlobalComponents = [
  ["AppIcon", LazyAppIcon],
["Card", LazyCard],
["CreateNewClaimHyperlink", LazyCreateNewClaimHyperlink],
["IconCard", LazyIconCard],
["ShipmentCard", LazyShipmentCard],
["StepSubtitle", LazyStepSubtitle],
["ParcelLab", LazyParcelLab],
["DropArea", LazyDropArea],
["MediaUploader", LazyMediaUploader],
["BaseModal", LazyBaseModal],
["CollectSignatureModal", LazyCollectSignatureModal],
["EditInStoreDetailsModal", LazyEditInStoreDetailsModal],
["EditShippingAddressModal", LazyEditShippingAddressModal],
["ItemsModal", LazyItemsModal],
["OtaModal", LazyOtaModal],
["OutOfWarrantyModal", LazyOutOfWarrantyModal],
["ProcessFileClaim", LazyProcessFileClaim],
["ProcessReturns", LazyProcessReturns],
["ProcessShippingClaims", LazyProcessShippingClaims],
["ProcessWarrantyClaims", LazyProcessWarrantyClaims],
["ReturnsCard", LazyReturnsCard],
["ShippingClaimsCard", LazyShippingClaimsCard],
["PulseAiProductFinderModal", LazyPulseAiProductFinderModal],
["PulseConfirmShippingAddress", LazyPulseConfirmShippingAddress],
["PulseDeliveryIssueDetails", LazyPulseDeliveryIssueDetails],
["PulseDeliveryIssueDropdown", LazyPulseDeliveryIssueDropdown],
["PulseDeliveryIssueOptions", LazyPulseDeliveryIssueOptions],
["PulseItemCard", LazyPulseItemCard],
["PulseItemIssueCard", LazyPulseItemIssueCard],
["PulseItemIssueDetailModal", LazyPulseItemIssueDetailModal],
["PulseItemIssueDetailModalForm", LazyPulseItemIssueDetailModalForm],
["PulseItemIssueDetailModalProgressBar", LazyPulseItemIssueDetailModalProgressBar],
["PulseItemIssueDetailModalSelectCount", LazyPulseItemIssueDetailModalSelectCount],
["PulseItemIssueDetailModalSelectGranularity", LazyPulseItemIssueDetailModalSelectGranularity],
["PulseItemIssueDetails", LazyPulseItemIssueDetails],
["PulseOrderIssueOptions", LazyPulseOrderIssueOptions],
["PulseProductNotFoundForm", LazyPulseProductNotFoundForm],
["PulseRendered", LazyPulseRendered],
["PulseResolutionOptions", LazyPulseResolutionOptions],
["PulseSearchWarrantyProductsModal", LazyPulseSearchWarrantyProductsModal],
["PulseShippingAddress", LazyPulseShippingAddress],
["PulseUnavailableItemsResolution", LazyPulseUnavailableItemsResolution],
["PulseUploadedReceipts", LazyPulseUploadedReceipts],
["PulseContactInfoStep", LazyPulseContactInfoStep],
["PulseDateOfPurchaseStep", LazyPulseDateOfPurchaseStep],
["PulseProductSearchStep", LazyPulseProductSearchStep],
["PulseReceiptStep", LazyPulseReceiptStep],
["PulseReceiptUploadSection", LazyPulseReceiptUploadSection],
["PulseResolutionStep", LazyPulseResolutionStep],
["PulseBadge", LazyPulseBadge],
["PulseEmptyState", LazyPulseEmptyState],
["PulseLoadingSpinner", LazyPulseLoadingSpinner],
["PulseMediaCarousel", LazyPulseMediaCarousel],
["PulseTooltip", LazyPulseTooltip],
["PulseBanner", LazyPulseBanner],
["PulseBaseModal", LazyPulseBaseModal],
["PulseChatAttachment", LazyPulseChatAttachment],
["PulseCheckRadioButton", LazyPulseCheckRadioButton],
["PulseClaimFeed", LazyPulseClaimFeed],
["PulseClaimMetric", LazyPulseClaimMetric],
["PulseCustomerAddress", LazyPulseCustomerAddress],
["PulseCustomerAddresses", LazyPulseCustomerAddresses],
["PulseDataMetric", LazyPulseDataMetric],
["PulseFeedback", LazyPulseFeedback],
["PulseFulfillmentInfo", LazyPulseFulfillmentInfo],
["PulseInfoBanner", LazyPulseInfoBanner],
["PulseMessagingEvent", LazyPulseMessagingEvent],
["PulseMessagingEventDivider", LazyPulseMessagingEventDivider],
["PulseMessagingFeed", LazyPulseMessagingFeed],
["PulseModal", LazyPulseModal],
["PulsePlatformAvatar", LazyPulsePlatformAvatar],
["PulseProductDisplay", LazyPulseProductDisplay],
["PulseReshipRefundResolutionDetails", LazyPulseReshipRefundResolutionDetails],
["PulseStatusBadge", LazyPulseStatusBadge],
["PulseSuccessBanner", LazyPulseSuccessBanner],
["PulseTagList", LazyPulseTagList],
["PulseToggleDisplay", LazyPulseToggleDisplay],
["PulseTrackingInfo", LazyPulseTrackingInfo],
["PulseUserAvatar", LazyPulseUserAvatar],
["PulseWarningBanner", LazyPulseWarningBanner],
["PulseTable", LazyPulseTable],
["PulseTableGridSkeleton", LazyPulseTableGridSkeleton],
["PulseTableSkeleton", LazyPulseTableSkeleton],
["PulseAddBook", LazyPulseAddBook],
["PulseApiLogo", LazyPulseApiLogo],
["PulseArmraLogo", LazyPulseArmraLogo],
["PulseArrowsRightLeft", LazyPulseArrowsRightLeft],
["PulseBigCommerce", LazyPulseBigCommerce],
["PulseCart", LazyPulseCart],
["PulseCheckCircle", LazyPulseCheckCircle],
["PulseCheckoutBag", LazyPulseCheckoutBag],
["PulseChevronLeft", LazyPulseChevronLeft],
["PulseCircleLogo", LazyPulseCircleLogo],
["PulseClaimInfoSubscribedRightArrows", LazyPulseClaimInfoSubscribedRightArrows],
["PulseClaimTodoApprovedDeniedSolidArrow", LazyPulseClaimTodoApprovedDeniedSolidArrow],
["PulseClaimTodoClosedSolidArrow", LazyPulseClaimTodoClosedSolidArrow],
["PulseClaimTodoDashedArrow", LazyPulseClaimTodoDashedArrow],
["PulseClaimTodoOnholdDashedArrow", LazyPulseClaimTodoOnholdDashedArrow],
["PulseClaimTodoPendingDashedArrow", LazyPulseClaimTodoPendingDashedArrow],
["PulseClaimTodoSolidLine", LazyPulseClaimTodoSolidLine],
["PulseDatePicker", LazyPulseDatePicker],
["PulseEarthGlobeTimezone", LazyPulseEarthGlobeTimezone],
["PulseFolderCheck", LazyPulseFolderCheck],
["PulseFollowUp", LazyPulseFollowUp],
["PulseIconApprove", LazyPulseIconApprove],
["PulseIconArmra", LazyPulseIconArmra],
["PulseIconAvatar", LazyPulseIconAvatar],
["PulseIconBuilding", LazyPulseIconBuilding],
["PulseIconCheck", LazyPulseIconCheck],
["PulseIconClose", LazyPulseIconClose],
["PulseIconCreditCard", LazyPulseIconCreditCard],
["PulseIconCustom", LazyPulseIconCustom],
["PulseIconDanger", LazyPulseIconDanger],
["PulseIconDollar", LazyPulseIconDollar],
["PulseIconDrag", LazyPulseIconDrag],
["PulseIconEdit", LazyPulseIconEdit],
["PulseIconGoogle", LazyPulseIconGoogle],
["PulseIconInfo", LazyPulseIconInfo],
["PulseIconLock", LazyPulseIconLock],
["PulseIconLogo", LazyPulseIconLogo],
["PulseIconRefund", LazyPulseIconRefund],
["PulseIconSave", LazyPulseIconSave],
["PulseIconSend", LazyPulseIconSend],
["PulseIconShipment", LazyPulseIconShipment],
["PulseIconShopify", LazyPulseIconShopify],
["PulseIconWarning", LazyPulseIconWarning],
["PulseImageCancel", LazyPulseImageCancel],
["PulseInbox", LazyPulseInbox],
["PulseLineAlign", LazyPulseLineAlign],
["PulseLineAlphabet", LazyPulseLineAlphabet],
["PulseLineAngleDoubleLeft", LazyPulseLineAngleDoubleLeft],
["PulseLineAngleDoubleRight", LazyPulseLineAngleDoubleRight],
["PulseLineAngleDown", LazyPulseLineAngleDown],
["PulseLineAngleLeft", LazyPulseLineAngleLeft],
["PulseLineAngleRight", LazyPulseLineAngleRight],
["PulseLineAngleUp", LazyPulseLineAngleUp],
["PulseLineAppleAlt", LazyPulseLineAppleAlt],
["PulseLineArchive", LazyPulseLineArchive],
["PulseLineArrow", LazyPulseLineArrow],
["PulseLineArrowDownRight", LazyPulseLineArrowDownRight],
["PulseLineArrowLeft", LazyPulseLineArrowLeft],
["PulseLineArrowRight", LazyPulseLineArrowRight],
["PulseLineAt", LazyPulseLineAt],
["PulseLineBalanceScale", LazyPulseLineBalanceScale],
["PulseLineBars", LazyPulseLineBars],
["PulseLineBell", LazyPulseLineBell],
["PulseLineBold", LazyPulseLineBold],
["PulseLineBolt", LazyPulseLineBolt],
["PulseLineBookMedical", LazyPulseLineBookMedical],
["PulseLineBox", LazyPulseLineBox],
["PulseLineBrain", LazyPulseLineBrain],
["PulseLineBuilding", LazyPulseLineBuilding],
["PulseLineCameraPlus", LazyPulseLineCameraPlus],
["PulseLineCameraQuestion", LazyPulseLineCameraQuestion],
["PulseLineCancel", LazyPulseLineCancel],
["PulseLineChart", LazyPulseLineChart],
["PulseLineChatBubbleUser", LazyPulseLineChatBubbleUser],
["PulseLineCheckCircle", LazyPulseLineCheckCircle],
["PulseLineCircle", LazyPulseLineCircle],
["PulseLineClipboardAlt", LazyPulseLineClipboardAlt],
["PulseLineClockThree", LazyPulseLineClockThree],
["PulseLineCodeBranch", LazyPulseLineCodeBranch],
["PulseLineCoins", LazyPulseLineCoins],
["PulseLineCommentAlt", LazyPulseLineCommentAlt],
["PulseLineCommentAltBlock", LazyPulseLineCommentAltBlock],
["PulseLineCommentDots", LazyPulseLineCommentDots],
["PulseLineCommentMessage", LazyPulseLineCommentMessage],
["PulseLineCommentQuestion", LazyPulseLineCommentQuestion],
["PulseLineComparison", LazyPulseLineComparison],
["PulseLineCopy", LazyPulseLineCopy],
["PulseLineCornerUpLeftAlt", LazyPulseLineCornerUpLeftAlt],
["PulseLineCornerUpRightAlt", LazyPulseLineCornerUpRightAlt],
["PulseLineCreditCard", LazyPulseLineCreditCard],
["PulseLineDashboard", LazyPulseLineDashboard],
["PulseLineDownloadAlt", LazyPulseLineDownloadAlt],
["PulseLineDraggabledots", LazyPulseLineDraggabledots],
["PulseLineEdit", LazyPulseLineEdit],
["PulseLineEditAlt", LazyPulseLineEditAlt],
["PulseLineEllipsisH", LazyPulseLineEllipsisH],
["PulseLineExclamationCircle", LazyPulseLineExclamationCircle],
["PulseLineExclamationOctagon", LazyPulseLineExclamationOctagon],
["PulseLineExport", LazyPulseLineExport],
["PulseLineExternalLinkAlt", LazyPulseLineExternalLinkAlt],
["PulseLineEye", LazyPulseLineEye],
["PulseLineEyeSlash", LazyPulseLineEyeSlash],
["PulseLineFileCopyAlt", LazyPulseLineFileCopyAlt],
["PulseLineFileLandscape", LazyPulseLineFileLandscape],
["PulseLineFilter", LazyPulseLineFilter],
["PulseLineFire", LazyPulseLineFire],
["PulseLineFolder", LazyPulseLineFolder],
["PulseLineFolderOpen", LazyPulseLineFolderOpen],
["PulseLineFont", LazyPulseLineFont],
["PulseLineGithubAlt", LazyPulseLineGithubAlt],
["PulseLineGlobe", LazyPulseLineGlobe],
["PulseLineImage", LazyPulseLineImage],
["PulseLineImageBroken", LazyPulseLineImageBroken],
["PulseLineImport", LazyPulseLineImport],
["PulseLineInbox", LazyPulseLineInbox],
["PulseLineInfoCircle", LazyPulseLineInfoCircle],
["PulseLineItalic", LazyPulseLineItalic],
["PulseLineLeftIndent", LazyPulseLineLeftIndent],
["PulseLineLinkAlt", LazyPulseLineLinkAlt],
["PulseLineListOl", LazyPulseLineListOl],
["PulseLineListUl", LazyPulseLineListUl],
["PulseLineLock", LazyPulseLineLock],
["PulseLineMapPinAlt", LazyPulseLineMapPinAlt],
["PulseLineMessage", LazyPulseLineMessage],
["PulseLineMicrophone", LazyPulseLineMicrophone],
["PulseLineMinusCircle", LazyPulseLineMinusCircle],
["PulseLineMoney", LazyPulseLineMoney],
["PulseLineMoneyWithdraw", LazyPulseLineMoneyWithdraw],
["PulseLineMoon", LazyPulseLineMoon],
["PulseLineMultiply", LazyPulseLineMultiply],
["PulseLinePalette", LazyPulseLinePalette],
["PulseLinePaperclip", LazyPulseLinePaperclip],
["PulseLinePen", LazyPulseLinePen],
["PulseLinePhone", LazyPulseLinePhone],
["PulseLinePlug", LazyPulseLinePlug],
["PulseLinePlus", LazyPulseLinePlus],
["PulseLinePlusCircle", LazyPulseLinePlusCircle],
["PulseLinePlusSquare", LazyPulseLinePlusSquare],
["PulseLineRedo", LazyPulseLineRedo],
["PulseLineRefresh", LazyPulseLineRefresh],
["PulseLineRightIndentAlt", LazyPulseLineRightIndentAlt],
["PulseLineRobot", LazyPulseLineRobot],
["PulseLineRocket", LazyPulseLineRocket],
["PulseLineSearch", LazyPulseLineSearch],
["PulseLineSetting", LazyPulseLineSetting],
["PulseLineShield", LazyPulseLineShield],
["PulseLineShieldCheck", LazyPulseLineShieldCheck],
["PulseLineShoppingBag", LazyPulseLineShoppingBag],
["PulseLineSlack", LazyPulseLineSlack],
["PulseLineSort", LazyPulseLineSort],
["PulseLineStar", LazyPulseLineStar],
["PulseLineSun", LazyPulseLineSun],
["PulseLineSwatchbook", LazyPulseLineSwatchbook],
["PulseLineSync", LazyPulseLineSync],
["PulseLineTable", LazyPulseLineTable],
["PulseLineTag", LazyPulseLineTag],
["PulseLineTimes", LazyPulseLineTimes],
["PulseLineTimesCircle", LazyPulseLineTimesCircle],
["PulseLineToggleOff", LazyPulseLineToggleOff],
["PulseLineToggleOn", LazyPulseLineToggleOn],
["PulseLineTransaction", LazyPulseLineTransaction],
["PulseLineTrashAlt", LazyPulseLineTrashAlt],
["PulseLineTruck", LazyPulseLineTruck],
["PulseLineUnderline", LazyPulseLineUnderline],
["PulseLineUpload", LazyPulseLineUpload],
["PulseLineUsdCircle", LazyPulseLineUsdCircle],
["PulseLineUsersAlt", LazyPulseLineUsersAlt],
["PulseLineWrench", LazyPulseLineWrench],
["PulseLoopreturns", LazyPulseLoopreturns],
["PulseMagentoLogo", LazyPulseMagentoLogo],
["PulseNoResponse", LazyPulseNoResponse],
["PulseOutlineCube", LazyPulseOutlineCube],
["PulseOutlineEnvelope", LazyPulseOutlineEnvelope],
["PulseOutsideOp", LazyPulseOutsideOp],
["PulsePackage", LazyPulsePackage],
["PulsePackageArrived", LazyPulsePackageArrived],
["PulsePlayCircle", LazyPulsePlayCircle],
["PulsePlusCircle", LazyPulsePlusCircle],
["PulseQueueList", LazyPulseQueueList],
["PulseRefreshResentMail", LazyPulseRefreshResentMail],
["PulseRiseaiLogo", LazyPulseRiseaiLogo],
["PulseShieldCheck", LazyPulseShieldCheck],
["PulseShipstation", LazyPulseShipstation],
["PulseShopifyAvatar", LazyPulseShopifyAvatar],
["PulseShopifyBag", LazyPulseShopifyBag],
["PulseSolidCheckCircle", LazyPulseSolidCheckCircle],
["PulseSolidStar", LazyPulseSolidStar],
["PulseTableDeleteColumn", LazyPulseTableDeleteColumn],
["PulseTableDeleteRow", LazyPulseTableDeleteRow],
["PulseTableInsertColumnAfter", LazyPulseTableInsertColumnAfter],
["PulseTableInsertColumnBefore", LazyPulseTableInsertColumnBefore],
["PulseTableInsertRowAbove", LazyPulseTableInsertRowAbove],
["PulseTableInsertRowAfter", LazyPulseTableInsertRowAfter],
["PulseTableOptions", LazyPulseTableOptions],
["PulseTableSettings", LazyPulseTableSettings],
["PulseTipaltiLogo", LazyPulseTipaltiLogo],
["PulseTrackstar", LazyPulseTrackstar],
["PulseXCircle", LazyPulseXCircle],
["PulseXMark", LazyPulseXMark],
["PulseAccordionCard", LazyPulseAccordionCard],
["PulseBasicCard", LazyPulseBasicCard],
["PulseItemsAccordion", LazyPulseItemsAccordion],
["PulsePageIcon", LazyPulsePageIcon],
["PulseShippingClaim", LazyPulseShippingClaim],
["PulseSingleClaim", LazyPulseSingleClaim],
["PulseTabbedNav", LazyPulseTabbedNav],
["PulseWarrantyClaim", LazyPulseWarrantyClaim],
["PulseButton", LazyPulseButton],
["PulseButtonCard", LazyPulseButtonCard],
["PulseChatImageUploader", LazyPulseChatImageUploader],
["PulseColorInput", LazyPulseColorInput],
["PulseCustomDatePicker", LazyPulseCustomDatePicker],
["PulseDateRangePicker", LazyPulseDateRangePicker],
["PulseDropdown", LazyPulseDropdown],
["PulseIconButton", LazyPulseIconButton],
["PulseInput", LazyPulseInput],
["PulseLabelPopper", LazyPulseLabelPopper],
["PulseMessageBox", LazyPulseMessageBox],
["PulseMultiDropdown", LazyPulseMultiDropdown],
["PulseMultiSelectDropdown", LazyPulseMultiSelectDropdown],
["PulseOptionsMenu", LazyPulseOptionsMenu],
["PulsePasswordInput", LazyPulsePasswordInput],
["PulseRadioButton", LazyPulseRadioButton],
["PulseRadioQuestion", LazyPulseRadioQuestion],
["PulseRangeSlider", LazyPulseRangeSlider],
["PulseRteFileComponent", LazyPulseRteFileComponent],
["PulseRteMentionList", LazyPulseRteMentionList],
["PulseRteVideoComponent", LazyPulseRteVideoComponent],
["PulseRichTextEditor", LazyPulseRichTextEditor],
["PulseSelect", LazyPulseSelect],
["PulseTagSelect", LazyPulseTagSelect],
["PulseTextArea", LazyPulseTextArea],
["PulseToggle", LazyPulseToggle],
["PulseValidationGroup", LazyPulseValidationGroup],
  
]

export default defineNuxtPlugin({
  name: 'nuxt:global-components',
  setup (nuxtApp) {
    for (const [name, component] of lazyGlobalComponents) {
      nuxtApp.vueApp.component(name, component)
      nuxtApp.vueApp.component('Lazy' + name, component)
    }
  }
})
